<template lang="pug">
div
  el-row.radio-buttons(:gutter="30" v-if="tipoCadastro === 'ONEROSO' || cadastroFormulario.tipo === 'ONEROSO'")
    el-col.inputDiv(:span="8")
      el-radio(v-model="cadastroFormulario.interessado.pessoa.isPessoaFisica" :label="true") Pessoa Física
      el-radio(v-model="cadastroFormulario.interessado.pessoa.isPessoaFisica" :label="false") Pessoa Jurídica
  app-pessoa-fisica-retificacao(
    v-if="cadastroFormulario.interessado && cadastroFormulario.interessado.pessoa && cadastroFormulario.interessado.pessoa.isPessoaFisica",
    nomeAba='Interessado',
    :observer="observer"
    @changeEstadoCivil="getEstadoCivil",
    @changePossuiCertidaoObito="possuiCertidaoObito"
    @usarDadosCadastrante="usarDadosCadastrante"
  )
  app-pessoa-juridica(
    v-if="cadastroFormulario.interessado && cadastroFormulario.interessado.pessoa && !cadastroFormulario.interessado.pessoa.isPessoaFisica",
    :pessoa='cadastroFormulario.interessado.pessoa',
    nomeAba='Interessado',
    :observer="observer"
  )
  app-endereco-retificacao(
    v-if='enderecoInteressado',
    :endereco='enderecoInteressado',
    nomeAba='Interessado'
  )
  el-row(:gutter="30" style="margin-top: 20px")
    el-col(:span="24")
      app-documentos-retificacao(
        v-if="tiposDocumentos.length"
        :maxSize='20',
        :valid-extensions="extensoes",
        :documentos="documentosInteressado"
        :tiposDocumentos="tiposDocumentos",
        :tiposDocumentosObrigatorios="tiposDocumentos",
        :observer="this.$refs.validation",
        :isDocumentoImagex="true",
        titulo="Documentação",
        aba="Interessado",
        idUploadDocumento="appUploadDocumentosInteressado",
        @addedDoc="handleDocs",
        @removedDoc="removerDocs"
      )
  app-socio-retificacao(
    v-if="cadastroFormulario.interessado && cadastroFormulario.interessado.pessoa && !cadastroFormulario.interessado.pessoa.isPessoaFisica",
    :socios="cadastroFormulario.interessado.sociosRepresentantesLegais",
    :idProcesso="Number(idProcesso)"
  )
</template>

<script>
import AppDocumentosRetificacao from '@/screens/central/components/cadastro/AppDocumentosRetificacao'
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppPessoaFisicaRetificacao from '@/components/AppPessoaFisicaRetificacao'
import AppEnderecoRetificacao from '@/components/AppEnderecoRetificacao'
import AppPessoaJuridica from '@/components/AppPessoaJuridicaRetificacao'
import AppLabel from '@/components/AppLabel'
import emptyPessoa from '@/screens/central/cadastros/para/empty/emptyPessoa'
import AppSocioRetificacao from '@/screens/central/components/cadastro/AppSocioRetificacao'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: ['cadastro', 'observer', 'idProcesso'],

  components: {
    AppDocumentosRetificacao,
    AppPessoaFisicaRetificacao,
    AppPessoaJuridica,
    AppEnderecoRetificacao,
    AppLabel,
    AppSocioRetificacao
  },

  data () {
    return {
      documentos: [],
      documentosObrigatorios: [],
      extensoes: ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'],
      numero: null,
      tiposDocumentos: [],
      conjuge: null,
      documentosInteressado: [],
      documentosInteressadoAlterados: [],
      flagTela: false,
      cadastroFormulario: [],
      teste: null,
      estadoCivil: null,
      listDocs: [],
      tipoCadastro: null,
      radio: null,
      enderecoCadastrante: null
    }
  },

  async created () {
    const jsonCadastro = await this.findByIdCadastro(this.idProcesso)
    this.CADASTRO_INICIAL(JSON.parse(jsonCadastro.json))
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    this.documentosInteressado = this.cadastroFormulario?.interessado?.documentos
    this.tipoCadastro = this.tipo
    this.radio = this.cadastroFormulario.interessado.pessoa.isPessoaFisica
    const resp = await this.findDocumentosByCodigo({
      codigo: this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil
        ? this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil
        : 'PJ'
    })
    resp.forEach(item => {
      if (item.codigo === 'ATESTADO_OBITO_CONJUGE' && this.cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito) {
        item.showValidacao = true
      } else if (item.codigo === 'ATESTADO_OBITO_CONJUGE' && !this.cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito) {
        item.showValidacao = false
      }
    })
    this.tiposDocumentos = [...resp]
  },

  computed: {
    enderecoInteressado () {
      return this.cadastroFormulario?.interessado?.pessoa?.endereco
    },
    ...mapGetters({
      cadastroJson: 'retificacao/cadastro',
      versao: 'retificacao/versao',
      tipo: 'retificacao/tipo'
    })
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      findDocumentosByCodigo: 'tipoDocumento/findTiposDocumentoByCodigo',
      baixarDocumento: 'cadastro/downloadDocumentoCentral',
      findPessoa: 'pessoa/findByCpfOrCnpj',
      findByIdCadastro: 'cadastro/findCadastroById',
      salvarCadastroRetificacao: 'cadastroRetificacao/salvarCadastroByIdProcesso',
      saveRelDocumentoProcessoRetificacao: 'relDocumentoProcessoRetificacao/saveRelDocumentoProcessoRetificacao',
      deleteDocumentoById: 'documentos/deleteDocumentoById'
    }),
    ...mapActions('retificacao', ['update', 'updateObjeto', 'updateNacionalidade']),
    ...mapMutations(
      'retificacao', ['CADASTRO_INICIAL', 'CHANGE_ESTADO_CIVIL', 'CHANGE_NACIONALIDADE', 'CHANGE_NACIONALIDADE_CONJUGE', 'CHANGE_TIPO_INTERESSADO']
    ),

    usarDadosCadastrante (val) {
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },

    async handleDocs (dados) {
      const doc = {
        id: null,
        _id: dados.id,
        key: dados.fileKey,
        hash: null,
        nome: dados.fileName,
        tipo: dados.tipoDocumento,
        base64: null,
        caminho: null
      }
      this.documentosInteressadoAlterados.push(doc)
      const newDoc = await this.createDocByKey(doc)
      this.documentosInteressado.push(newDoc)
      this.listDocs = [...this.documentosInteressado]
      const payload = {
        idDocumento: newDoc.id,
        idProcesso: this.idProcesso
      }
      await this.saveRelDocumentoProcessoRetificacao(payload)
    },

    async removerDocs (doc) {
      if (doc.id) {
        this.documentosInteressadoAlterados = this.documentosInteressadoAlterados.filter(item => item.id !== doc.id)
      } else {
        this.documentosInteressadoAlterados = this.documentosInteressadoAlterados.filter(item => item.caminho !== doc.fileKey)
      }
      this.interessado = {
        ...this.interessado,
        documentos: this.documentosInteressadoAlterados
      }
      this.listDocs = [...this.documentosInteressado.filter(documento => doc.id !== documento.id)]
      if (doc?.id) {
        await this.deleteDocumentoById(doc.id)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.fileName)
    },
    async createDocByKey (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/createByKey`,
        data: documento
      })
      return file
    },

    downloadArquivo (arquivo) {
      this.getDownload(arquivo)
    },

    clearDocumentos (event) {
      this.confirmBox('Ao alterar o tipo de pessoa você perderá os dados preenchidos. Deseja confirmar?', this.$messages.TITULO_WARNING,
        () => {
          this.cadastroFormulario.interessado.pessoa.telefones = []
          if (this.cadastroFormulario.interessado.pessoa.tipo === 'PF') {
            this.cadastroFormulario.interessado.pessoa.email = null
            this.cadastroFormulario.interessado.pessoa.pessoaFisica.telefones = []
            this.cadastroFormulario.interessado.pessoa.pessoaFisica = emptyPessoa.pessoaFisica
          } else {
            this.cadastroFormulario.interessado.pessoa.pessoaJuridica = emptyPessoa.pessoaJuridica
            this.cadastroFormulario.interessado.pessoa.pessoaJuridica.telefones = []
          }
          this.cadastroFormulario.interessado.pessoa.tipo = event.target.value
          this.cadastroFormulario.interessado.documentos = []

          this.$emit('changedTipoPessoa', this.event.target)
        },
        () => {
        }, 'Sim', 'Não')
    },
    async getEstadoCivil (val) {
      const newTiposDocumentos = await this.findDocumentosByCodigo({
        codigo: val.pessoaFisica.estadoCivil
      })
      newTiposDocumentos.forEach(item => {
        if (item.codigo === 'ATESTADO_OBITO_CONJUGE' && this.cadastroFormulario?.interessado?.conjuge?.pessoa?.pessoaFisica?.temCertidaoObito) {
          item.showValidacao = true
        } else if (item.codigo === 'ATESTADO_OBITO_CONJUGE' && !this.cadastroFormulario?.interessado?.conjuge?.pessoa?.pessoaFisica?.temCertidaoObito) {
          item.showValidacao = false
        }
      })
      this.$set(this, 'tiposDocumentos', newTiposDocumentos)
    },
    possuiCertidaoObito (val) {
      this.tiposDocumentos.forEach(item => {
        if (item.codigo === 'ATESTADO_OBITO_CONJUGE' && val) {
          item.showValidacao = true
        } else {
          item.showValidacao = false
        }
      })
    },
    async getTipoDocumentos (val) {
      const resp = await this.findDocumentosByCodigo({
        codigo: val
          ? this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil || null
          : 'PJ'
      })
      this.tiposDocumentos = [...resp]
    },
    montarJson () {
      const jsonCadastro = {
        tipo: this.tipo,
        versao: this.versao,
        dados: {
          cadastro: this.cadastroFormulario
        }
      }
      return JSON.stringify(jsonCadastro)
    }
  },

  watch: {
    'cadastroFormulario.interessado.pessoa.isPessoaFisica' (val) {
      this.CHANGE_TIPO_INTERESSADO(val)
      this.update({field: 'interessado.pessoa.isPessoaFisica', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      this.getTipoDocumentos(val)
      this.documentosInteressado = this.cadastroFormulario.interessado.documentos
    },
    'cadastroFormulario.interessado.pessoa.endereco.logradouro' (val) {
      this.update({field: 'interessado.pessoa.endereco.logradouro', value: val})
    },
    'cadastroFormulario.interessado.pessoa.endereco.bairro' (val) {
      this.update({field: 'interessado.pessoa.endereco.bairro', value: val})
    },
    'cadastroFormulario.interessado.pessoa.endereco.complemento' (val) {
      this.update({field: 'interessado.pessoa.endereco.complemento', value: val})
    },
    'cadastroFormulario.interessado.pessoa.endereco.numero' (val) {
      this.update({field: 'interessado.pessoa.endereco.numero', value: val})
    },
    'cadastroFormulario.interessado.pessoa.endereco.semNumero' (val) {
      this.update({field: 'interessado.pessoa.endereco.semNumero', value: val})
    },
    'cadastroFormulario.interessado.pessoa.endereco.cep' (val) {
      this.update({field: 'interessado.pessoa.endereco.cep', value: val})
    },
    'cadastroFormulario.interessado.pessoa.endereco.municipio.uf' (val) {
      this.update({field: 'interessado.pessoa.endereco.municipio.uf', value: val})
    },
    'cadastroFormulario.interessado.pessoa.endereco.municipio.codigoEstado' (val) {
      if (val) {
        this.update({field: 'interessado.pessoa.endereco.municipio.estado', value: val})
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      }
    },
    'cadastroFormulario.interessado.pessoa.endereco.municipio.nome' (val) {
      if (val) {
        const campoValor = [
          {field: 'interessado.pessoa.endereco.municipio.nome', value: val.nome},
          {field: 'interessado.pessoa.endereco.municipio.estado', value: val.codigoEstado || val.estado},
          {field: 'interessado.pessoa.endereco.municipio.id', value: val.id}
        ]
        this.updateObjeto({value: campoValor})
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      }
    },
    'listDocs' (val) {
      this.update({field: 'interessado.documentos', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      const payload = {
        idProcesso: this.idProcesso,
        cadastro: this.montarJson()
      }
      this.salvarCadastroRetificacao(payload)
    },
    'cadastroFormulario.interessado.pessoa.pessoaJuridica.razaoSocial' (val) {
      this.update({field: 'interessado.pessoa.pessoaJuridica.razaoSocial', value: val})
    },
    'cadastroFormulario.interessado.pessoa.pessoaJuridica.cnpj' (val) {
      this.update({field: 'interessado.pessoa.pessoaJuridica.cnpj', value: val})
    }

  }
}
</script>

<style lang="scss" scoped>
.radio-buttons {
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/Interessado.vue